import React, {Component} from 'react';
import { Provider, observer } from 'mobx-react';
import { configure } from 'mobx';
import rootStore from "../stores/rootStore";
import DynamicTable from "./DynamicTable";
import { StoreContext } from "../stores/contexts";
// import 'tippy.js/dist/tippy.css'; // optional
// import 'tippy.js/themes/light.css';

configure({
    enforceActions: "never",
    isolateGlobalState: true
});

const matchAll = require('string.prototype.matchall');
matchAll.shim();

class DynamicTableApp extends Component {
  constructor(props) {
    super(props);

    this._rootStore=new rootStore(props);
    if(props.communicatorRef) {
      props.communicatorRef(this._rootStore.communicatorStore);
    }
  }
  render() {
    return (
      <StoreContext.Provider value={this._rootStore.getStores()}>
        {this.props.useExternalRenderMap?(
          <DynamicTable useExternalRenderMap={this.props.useExternalRenderMap} externalRenderer={this.props.externalRenderer}>
            {(RetOb)=>{
              return this.props.children(RetOb);
            }}
          </DynamicTable>
        ):(
          <DynamicTable useExternalRenderMap={this.props.useExternalRenderMap} externalRenderer={this.props.externalRenderer} />
        )}

      </StoreContext.Provider>
    )
    /*
    return (
      <Provider {...this._rootStore.getStores()}>
        <DynamicTable />
      </Provider>
    )
    */
  }
}

export default observer(DynamicTableApp);